import type { MenuItem } from "@ctrl/controller-rpc";

import { getMenuItemKey } from "@/components/menu/menuItems";

type MergeReorderedMenuItemsForReplaceArgs = {
  currentItems: MenuItem[];
  previousManagedItems: MenuItem[];
  reorderedManagedItems: MenuItem[];
};

/**
 * Builds a full replacement payload from a reordered subset of menu items.
 *
 * Reorder UIs intentionally hide some persisted items. Those hidden items are
 * unmanaged by the reorder operation and must be preserved when calling the
 * full-replacement menuItems.replace RPC.
 */
export function mergeReorderedMenuItemsForReplace({
  currentItems,
  previousManagedItems,
  reorderedManagedItems,
}: MergeReorderedMenuItemsForReplaceArgs): MenuItem[] {
  const managedItemIds = new Set(previousManagedItems.map(getMenuItemKey));
  const reorderedItems = [...reorderedManagedItems];

  const result = currentItems.flatMap((item) => {
    if (!managedItemIds.has(getMenuItemKey(item))) return [item];

    const replacement = reorderedItems.shift();
    return replacement ? [replacement] : [];
  });

  return [...result, ...reorderedItems];
}
